function InvestmentPlan($container, $plansContainer, type, onDestroy, fullWidth) {
	var MOBILE_BREAKPOINT = 992;
	var $svg = $container.find('svg');
	var $img = $container.find('img');
	var $el;
    var $panzoom = $container.find('.investment-plan__panzoom');
    var $body = $('body');
    
    var $plansLinks = $('a[href="#plan"]');
    
    var moveStep = 30;
    
    var initialized = false;
    
    var lastBuildingsData;
    var lastFloorsData;
    var lastFlatsData;
    
    var tooltipVisible = false;
    var lastTooltipId = '';
    var lastTooltipEvent = null;
	var lastTooltipElement = null;
    var $tooltip = null;
    var tooltipHalfWidth;
    
    var currentZoom = 1;
    
    
    var getPanzoomHeight = function() {
    	var css = $panzoom.css('height');
    	if(-1 !== css.indexOf('%')) {
    		return window.innerHeight;
    	}
    	return $panzoom.parent().height();
    };
    
	var getSizeData = function() {
		var out = {}
		var sectionWidth;
	    var panzoomHeight;
	    var elWidth;
	    var elHeight;
	    var prop;
	    var newImageWidth;
	    var minScale;
	    var maxScale;
	    var wasHidden = false;
	    
	    if(!$container.is(':visible')) {
	    	wasHidden = true;
	    	$container.show();
	    }
	    
	    sectionWidth = $container.width();
	    panzoomHeight = getPanzoomHeight();
	    
	    elWidth = $el.width();
	    elHeight = $el.height();
	    
	    if(!fullWidth) {
		    proportion = elWidth/elHeight;
		    newImageWidth = panzoomHeight * proportion;
		    minScale = sectionWidth/newImageWidth;
		    if(minScale < 1) {
		    	minScale = 1;
		    }
		    maxScale = minScale + 1;
	    } else {
	    	newImageWidth = sectionWidth;
	    	minScale = 1;
	    }
	    
	    if(window.innerWidth < 800) {
	    	maxScale = 4;
	    } else {
	    	maxScale = 2.5;
	    }
	    
	    if(wasHidden){
	    	$container.hide();
	    }
	    
	    return {
	    	minScale: minScale,
	    	maxScale: maxScale,
	    	requiredImageWidth: newImageWidth,
	    	requiredPanzoomHeight: panzoomHeight,
	    	elHeight: elHeight,
	    	elWidth: elWidth,
	    	sectionWidth: sectionWidth
	    };
	};
	
	var checkMode = function() {
		var parentIsBody = $container.parent().get(0) == $body.get(0); 
		if(window.innerWidth < MOBILE_BREAKPOINT) {
			if(false === $container.hasClass('investment-plan--mobile')) {
				$body.append($container);
				$container.addClass('investment-plan--mobile');
			}
		} else if(true === $container.hasClass('investment-plan--mobile')) {
			$plansContainer.append($container);
			$container.removeClass('investment-plan--mobile');
			$container.show();
		}
	};
	
	var openMobilePlan = function() {
		if(window.innerWidth < MOBILE_BREAKPOINT) {
			$container.addClass('investment-plan--mobile--active');
			windowResized();
			$container.hide();
			$container.fadeIn();
			return false;
		}
	};
	
	var closeMobilePlan = function() {
		var $cnt = $container;
		if($cnt.hasClass('investment-plan--mobile--active') && false === $cnt.hasClass('investment-plan--mobile--hiding')) {
			$cnt.addClass('investment-plan--mobile--hiding');
			$cnt.fadeOut(function() {
				$cnt.removeClass('investment-plan--mobile--active');
				$cnt.removeClass('investment-plan--mobile--hiding');
			});
			$cnt.trigger('closeMobile');
		}
	};
	
	var hidePlan = function() {
		var $cnt = $container;
		if($container.hasClass('investment-plan--mobile--active') && false === $container.hasClass('investment-plan--mobile--hiding')) {
			$container.addClass('investment-plan--mobile--hiding');
			$container.fadeOut(function() {
				if($container) {
				$container.removeClass('investment-plan--mobile--active');
				$container.removeClass('investment-plan--mobile--hiding');
				$container.trigger('hide');
				}
			});
		} else {
			$container.fadeOut(function() {
				$container.trigger('hide');
			});
		}
	};
	
	var centerPan = function() {
		var sizeData;
		var isHidden = false;
		if(false === $container.is(':visible')) {
			$container.show();
			isHidden = true;
		}
		
		sizeData = getSizeData();
		$panzoom
		.panzoom('zoom', sizeData.minScale)
		.panzoom('pan', (-sizeData.elWidth/2)+(sizeData.sectionWidth/2), 0, {relative: false});
			
		if(isHidden) {
			$container.hide();
		}
	};
	
	var windowResized = function() {
		var sizeData;
		checkMode();
		$panzoom.panzoom('zoom', 1);
		sizeData = getSizeData();
	    $el.css({
	        width: sizeData.requiredImageWidth,
	        height: sizeData.requiredPanzoomHeight
	    });
	    $el.get(0).offsetHeight;
	    
	    $panzoom.css({
	        width: sizeData.requiredImageWidth
	    });
		
		$panzoom.panzoom('option', {
			minScale: sizeData.minScale,
			startTransform: 'scale('+sizeData.minScale+')'
		})
	    .panzoom('resetDimensions')
	    .panzoom('reset')
		.panzoom('zoom', sizeData.minScale)
		;
		centerPan();
	};
	
	var moveRight = function() {
		var step = $panzoom.panzoom('getMatrix')[0] * -1 * moveStep;
		$panzoom.panzoom('pan', step, 0, {relative: true});
	};
	
	var moveLeft = function() {
		var step = $panzoom.panzoom('getMatrix')[0] * moveStep;
		$panzoom.panzoom('pan', step, 0, {relative: true});
	};
	
	var moveUp = function() {
		var step = $panzoom.panzoom('getMatrix')[0] * moveStep;
		$panzoom.panzoom('pan', 0, step, {relative: true});
	};
	
	var moveDown = function() {
		var step = $panzoom.panzoom('getMatrix')[0] * -1 * moveStep;
		$panzoom.panzoom('pan', 0, step, {relative: true});
	};
	
	var buildingClicked = function() {
		var $this = $(this);
    	var id = this.id.replace('building-', '');
    	if($this.hasClass('building--reserved') || $this.hasClass('building--free')) { 
    		$container.trigger('buildingClick', id);
    		$svg.find('.object-active').removeClass('object-active');
    		$this.addClass('object-active');
    	}
	};
	
	var floorClicked = function() {
		var $this = $(this);
    	var id = ~~this.id.replace('floor-', '');
    	var $active;
    	if($this.hasClass('floor--reserved') || $this.hasClass('floor--free') ) { 
    		$container.trigger('floorClick', id);
    		if($svg) {
    			$svg.find('.object-active').removeClass('object-active');
    		}
    		$this.addClass('object-active');
    	}
	};
	
	var flatClicked = function() {
		var $this = $(this);
    	var id = this.id.replace('flat-', '');
    	//if($this.hasClass('flat--sold') || $this.hasClass('flat--reserved') || $this.hasClass('flat--free')) {
    	if($this.hasClass('flat--reserved') || $this.hasClass('flat--free')) {
    		$container.trigger('flatClick', [id, $this.hasClass('object-active')]);
    	}
	};
	
	var planClickedCallback = function(e) {
		var $target = $(e.target);
		var $parent = $target.parent();
		closeTooltip();
		if($parent.prop('tagName').toLowerCase() === 'g') {
			if($parent.hasClass('building') || $parent.hasClass('building-house')) {
				buildingClicked.call($parent.get(0));
			} else if($parent.hasClass('floor')) {
				floorClicked.call($parent.get(0));
			} else if($parent.hasClass('flat')) {
				flatClicked.call($parent.get(0));
			}
		}
	};
	
	var openTooltip = function(html, id) {
		tooltipVisible = true;
		lastTooltipId = id;
		if(null !== $tooltip) {
			$tooltip.remove();
		}
		$tooltip = $('<div class="investment-tooltip tooltip">'+html+'</div>');
		$body.append($tooltip);
		tooltipHalfWidth = $tooltip.width()/2;
	};
	
	var moveTooltip = function(e) {
		if($tooltip) {
			lastTooltipEvent = e;
			lastTooltipElement = this;
			$tooltip.css({
				transform: 'translate3d('+(e.pageX - tooltipHalfWidth)+'px,'+(e.pageY + 30)+'px,0)'
			});
		}
	};
	
	var closeTooltip = function(e) {
		if(tooltipVisible) {
			lastTooltipEvent = null;
			lastTooltipElement = null;
			tooltipVisible = false;
			lastTooltipId = '';
			if(null !== $tooltip) {
				$tooltip.remove();
				$tooltip = null;
			}
		}
	};
	
	var reopenTooltip = function() {
		var event;
		var element;
		if(lastTooltipEvent) {
			event = lastTooltipEvent;
			element = lastTooltipElement;
			if(-1 !== lastTooltipId.indexOf('building')) {
				buildingTooltip.call(element, event);
			} else if(-1 !== lastTooltipId.indexOf('floor')) {
				floorTooltip.call(element, event);
			} else if(-1 !== lastTooltipId.indexOf('flat')) {
				flatTooltip.call(element, event);
			}
		}
	};
	
	var buildingTooltip = function(e) {
		var id;
		var $g;
		var status;
		var html = '';
		var flatsInfo = '';
		var houseInfo = '';
		
		var free = '';
		var reserved = '';
		if(!tooltipVisible || lastTooltipId !== 'building-'+this.id) {
			lastTooltipEvent = e;
			lastTooltipElement = this;
			$g = $(this);
			id = this.id.replace('building-', '');
			
			if(lastBuildingsData[id]) {
				if(lastBuildingsData[id].free > 0) {
					if(null !== lastBuildingsData[id].filterFree) {
						free += lastBuildingsData[id].filterFree+'/';
					}
					free += lastBuildingsData[id].free;
					flatsInfo += '<span class="investment-tooltip__free"><span class="investment-tooltip__label">'+window._LABEL_STATUS_FLAT_FREE+'</span>: <span class="investment-tooltip__value">'+free+'</span></span>';
				}
				if(lastBuildingsData[id].reserved > 0) {
					if(null !== lastBuildingsData[id].filterReserved) {
						reserved += lastBuildingsData[id].filterReserved+'/';
					}
					reserved += lastBuildingsData[id].reserved;
					flatsInfo += '<span class="investment-tooltip__reserved"><span class="investment-tooltip__label">'+window._LABEL_STATUS_FLAT_RESERVED+'</span>: <span class="investment-tooltip__value">'+reserved+'</span></span>';
				}
				
				if(lastBuildingsData[id] && lastBuildingsData[id].price && lastBuildingsData[id].area) {
					houseInfo += '<span class="investment-tooltip__row">'+window._LABEL_PRICE+': '+lastBuildingsData[id].price+'</span>';
					houseInfo += '<span class="investment-tooltip__row">'+window._LABEL_AREA+': '+lastBuildingsData[id].area+'</span>';
				}
			}
			
			if('' !== flatsInfo) {
				html += flatsInfo;
			} else {
				if($g.hasClass('building--free')) {
					status = window._LABEL_STATUS_BUILDING_FREE;
				} else if($g.hasClass('building--reserved')) {
					status = window._LABEL_STATUS_BUILDING_RESERVED;
				} else if($g.hasClass('building--sold')) {
					status = window._LABEL_STATUS_BUILDING_SOLD;
				} else {
					status = window._LABEL_STATUS_BUILDING_PLANED;
				}
				
				if('' !== houseInfo) {
					html += '<span class="investment-tooltip__details-title">'+status+'</span>';
					html += houseInfo;
				} else {
					html += '<span class="investment-tooltip__status">'+status+'</span>';
				}
			}
			
			openTooltip(html, 'building'+this.id);
		}
		moveTooltip.call(this, e);
	};
	
	var floorTooltip = function(e) {
		var id;
		var $g;
		var status;
		var html = '';
		var flatsInfo = '';
		var free = '';
		var reserved = '';
		if(!tooltipVisible || lastTooltipId !== 'floor-'+this.id) {
			lastTooltipEvent = e;
			lastTooltipElement = this;
			$g = $(this);
			id = this.id.replace('floor-', '');
			
			if(lastFloorsData[id]) {
				if(lastFloorsData[id].free > 0) {
					if(null !== lastFloorsData[id].filterFree) {
						free += lastFloorsData[id].filterFree+'/';
					}
					free += lastFloorsData[id].free;
					flatsInfo += '<span class="investment-tooltip__free"><span class="investment-tooltip__label">'+window._LABEL_STATUS_FLAT_FREE+'</span>: <span class="investment-tooltip__value">'+free+'</span></span>';
				}
				if(lastFloorsData[id].reserved > 0) {
					if(null !== lastFloorsData[id].filterReserved) {
						reserved += lastFloorsData[id].filterReserved+'/';
					}
					reserved += lastFloorsData[id].reserved;
					flatsInfo += '<span class="investment-tooltip__reserved"><span class="investment-tooltip__label">'+window._LABEL_STATUS_FLAT_RESERVED+'</span>: <span class="investment-tooltip__value">'+reserved+'</span></span>';
				}
			}
			
			if('' !== flatsInfo) {
				html += flatsInfo;
			} else {
				if($g.hasClass('floor--free')) {
					status = window._LABEL_STATUS_FLOOR_FREE;
				} else if($g.hasClass('floor--reserved')) {
					status = window._LABEL_STATUS_FLOOR_RESERVED;
				} else if($g.hasClass('floor--sold')) {
					status = window._LABEL_STATUS_FLOOR_SOLD;
				} else {
					status = window._LABEL_STATUS_FLOOR_NOT_AVALAIBLE;
				}
				html += '<span class="investment-tooltip__status">'+status+'</span>';
			}
			
			openTooltip(html, 'floor'+this.id);
		}
		moveTooltip.call(this, e);
	};
	
	var flatTooltip = function(e) {
		var id;
		var $g;
		var status;
		var html = '';
		var flatsInfo = '';
		if(!tooltipVisible || lastTooltipId !== 'flat-'+this.id) {
			lastTooltipEvent = e;
			lastTooltipElement = this;
			$g = $(this);
			id = this.id.replace('flat-', '');
			if($g.hasClass('flat--free')) {
				status = window._LABEL_STATUS_FLAT_FREE;
			} else if($g.hasClass('flat--reserved')) {
				status = window._LABEL_STATUS_FLAT_RESERVED;
			} else if($g.hasClass('flat--sold')) {
				status = window._LABEL_STATUS_FLAT_SOLD;
			} else {
				status = window._LABEL_STATUS_FLAT_NOT_AVALAIBLE;
			}
			html += '<span class="investment-tooltip__details-title">'+status+'</span>';
			if(lastFlatsData && lastFlatsData[id]) {
				html += '<span class="investment-tooltip__row">'+window._LABEL_PRICE+': '+lastFlatsData[id].price+'</span>';
				html += '<span class="investment-tooltip__row">'+window._LABEL_AREA+': '+lastFlatsData[id].area+'</span>';
			}
			
			openTooltip(html, 'flat'+this.id);
		}
		moveTooltip.call(this, e);
	};
	
	
	var initPlan = function() {
		var sizeData;
		var changed = false;
		var zoomStep;
		var lastCords = {
			x: -1,
			y: -1
		};
		currentZoom = 1;
		
		if(true === initialized) {
			return false;
		}
		
		initialized = true;
		$container.removeClass('investment-plan--hidden');
		checkMode();
		sizeData = getSizeData();
		zoomStep = (sizeData.maxScale - sizeData.minScale)/3;
		
	    $panzoom.css({
	        width: sizeData.requiredImageWidth
	    });
	    
	    $el.css({
	        width: sizeData.requiredImageWidth,
	        height: sizeData.requiredPanzoomHeight
	    });
	    
	    
	    window.panzoom = $panzoom;
	    $panzoom.on('pointerdown mousedown touchstart MSPointerDown', function(e) {
	    	if(e.clientX && e.clientY) {
		    	lastCords = {
	        		x: e.clientX,
	        		y: e.clientY
	        	};
	    	}
	    });
	    
	    $panzoom.on('mousemove', function(e) {
	    	var $target = $(e.target);
			var $parent = $target.parent();
			if($parent.prop('tagName').toLowerCase() === 'g') {
				if($parent.hasClass('building') || $parent.hasClass('building-house')) {
					buildingTooltip.call($parent.get(0), e);
				} else if($parent.hasClass('floor')) {
					floorTooltip.call($parent.get(0), e);
				} else if($parent.hasClass('flat')) {
					flatTooltip.call($parent.get(0), e);
				}
			} else {
				closeTooltip();
			}
	    });
	    
	    $panzoom.on('mouseout', function(e) {
	    	closeTooltip();
	    });
	    
	    $container.find(".investment-plan__button--zoom-in").click(function() {
	    	currentZoom += zoomStep;
	    	if(currentZoom > sizeData.maxScale) {
	    		currentZoom = sizeData.maxScale;
	    	}
	    	$panzoom.panzoom("zoom", currentZoom, { animate: true });
	    });
	    
	    $container.find(".investment-plan__button--zoom-out").click(function() {
	    	currentZoom -= zoomStep;
	    	if(currentZoom < sizeData.minScale) {
	    		currentZoom = sizeData.minScale;
	    	}
	    	$panzoom.panzoom("zoom", currentZoom, { animate: true });
	    });
	    
	    window.$plan = $panzoom;
	    $panzoom.panzoom({
	        transition: true,
	        duration: 200,
	        easing: "ease-in-out",
	        startTransform: 'scale('+sizeData.minScale+')',
	        minScale: sizeData.minScale,
	        maxScale: sizeData.maxScale,
	        contain: 'automatic',
	        onStart: function(e) {
	        	changed = false;
	        },
	        onEnd: function(e) {
        		var diffX = Math.abs(lastCords.x - e.clientX);
        		var diffY = Math.abs(lastCords.y - e.clientY);
        		
        		var ignoreChanged = diffX < 10 && diffY < 10;
        		
	        	if(changed === false || ignoreChanged) {
	        		planClickedCallback(e);
	        	}
	        	changed = false;
	        	lastCords = {
        			x: -1,
        			y: -1
	        	};
	        },
	        onChange: function(e) {
	        	changed = true;
	        }
	    })
	    .panzoom('zoom', true)
	    
	    $container.find(".investment-plan__button--arrow-up").click(moveUp);
	    $container.find(".investment-plan__button--arrow-down").click(moveDown);
	    $container.find(".investment-plan__button--arrow-left").click(moveLeft);
	    $container.find(".investment-plan__button--arrow-right").click(moveRight);
	    
	    $(window).on('resize', windowResized);
	    
	    $plansLinks.on('click', openMobilePlan);
	    $container.find('.investment-plan__button--close').click(closeMobilePlan);
	    $container.find('.investment-plan__button--back').click(hidePlan);
	    
	    centerPan();
	};
	
	var centerToObject = function($object, zoom) {
		var $panzoom = $container.find('.investment-plan__panzoom');
		var containerOffset = $container.offset();
		var visibleWidth;
		var visibleHeight;
		var marginWidth;
		var marginHeight;
		var mLeft;
		var mTop;
		var $objOffset;
		
		currentZoom = 2;
		
		if(window.innerWidth < 800) {
	    	currentZoom = 4;
	    }
		
		if(zoom) {
			$panzoom.panzoom("zoom", currentZoom, { animate: false });
		}
		
		visibleWidth = $panzoom.width()/currentZoom;
		visibleHeight = $panzoom.height()/currentZoom;
		
		marginWidth = (currentZoom * visibleWidth - visibleWidth)/2;
		marginHeight = (currentZoom * visibleHeight - visibleHeight)/2;
		
		$panzoom.panzoom('pan', marginWidth, marginHeight, {relative: false});
		
		objOffset = $object.offset();
		objOffset.left -= containerOffset.left;
		objOffset.top -= containerOffset.top;
		
		mLeft = (objOffset.left*-1)+marginWidth + ($container.width()/2 - $object.width()/2);
		mTop = (objOffset.top*-1)+marginHeight + ($container.height()/2 - $object.height()/2);
		$panzoom.panzoom('pan', mLeft, mTop, {relative: false});
	};
	
	this.updateBuildings = function(data) {
		var $building; 
		var building;
		
		lastBuildingsData = data;
		
		for(var buildingId in data) {
			building = data[buildingId];
			$building = $container.find('#building-'+buildingId);
			switch(building.status) {
				case 1:
					$building.addClass('building--free');
					break;
				case 2:
					$building.addClass('building--reserved');
					break;
				case 3:
					$building.addClass('building--sold');
					break;
			}
			if(building.hidden && true === building.hidden) {
				$building.addClass('building--hidden');
			} else {
				$building.removeClass('building--hidden');
			}
		}
		
		reopenTooltip();
	};
	
	this.updateFloors = function(data) {
		var floor;
		var $floor;
		
		lastFloorsData = data;
		
		$container.find('.floor').addClass('floor--sold');
		
		for(var floorId in data) {
			floor = data[floorId];
			$floor = $container.find('#floor-'+floorId);
			switch(floor.status) {
				case 1:
					$floor.addClass('floor--free');
					break;
				case 2:
					$floor.addClass('floor--reserved');
					break;
				case 3:
					$floor.addClass('floor--sold');
					break;
			}
			if(floor.hidden && true === floor.hidden) {
				$floor.addClass('floor--hidden');
			} else {
				$floor.removeClass('floor--hidden');
			}
		}
		
		reopenTooltip();
	};
	
	this.updateFlats = function(data, soldItems) {
		var flat;
		var $flat;
		
		lastFlatsData = data;
		
		for(var flatId in data) {
			flat = data[flatId];
			$flat = $container.find('#flat-'+flatId);
			switch(flat.status) {
				case 1:
					$flat.addClass('flat--free');
					break;
				case 2:
					$flat.addClass('flat--reserved');
					break;
				case 3:
					$flat.addClass('flat--sold');
					break;
			}
			if(flat.hidden && true === flat.hidden) {
				$flat.addClass('flat--hidden');
			} else {
				$flat.removeClass('flat--hidden');
			}
		}
		
		for(var i = 0, s = soldItems.length; i < s; ++i) {
			$flat = $container.find('#flat-'+soldItems[i]);
			$flat.addClass('flat--sold');
		}
		reopenTooltip();
	};
	
	var destroy = function() {
		$container.remove();
		$container = null;
		$svg = null;
		$img = null;
		$el = null;
	    $panzoom = null
	    $body = null;
	    $(window).off('resize', windowResized);
	    $plansLinks.off('click', openMobilePlan);
	    closeTooltip();
	    if(onDestroy) {
	    	onDestroy();
	    }
	};
	
	this.destroy = function() {
		destroy();
	};
	
	this.close = function() {
		if($container.hasClass('investment-plan--mobile')) {
			closeTooltip();
			closeMobilePlan();
		} else {
			closeTooltip();
			$container.fadeOut(function() {
				destroy();
			});
		}
	};
	
	this.closeMobile = function() {
		if($container.hasClass('investment-plan--mobile')) {
			closeTooltip();
			closeMobilePlan();
		}
	};
	
	this.on = function(event, callback) {
		$container.on(event, callback);
	};
	
	this.off = function(callback) {
		$container.off(event, callback);
	};
	
	this.getContainer = function() {
		return $container;
	};
	
	this.show = function(noFx, callback) {
    	$container.addClass('investment-plan--mobile--active');
    	if(noFx) {
    		$container.show();
    		if(callback) {
    			callback();
    		}
    	} else {
	    	$container.hide();
	    	$container.fadeIn(callback);
    	}
	};
	
	this.select = function(element, zoom) {
		var $object = $container.find('#'+element);
		$container.find('.object-active').removeClass('object-active');
		if($object.length > 0) {
			$object.addClass('object-active');
			if(zoom !== false) {
				if($container.is(':hidden')) {
					$container.show();
					centerToObject($object, zoom);
					$container.hide();
				} else {
					centerToObject($object, zoom);
				}
			}
		}
	};
	
	this.closeTooltip = function() {
		closeTooltip();
	};
	
	this.unmark = function() {
		$svg.find('.object-active').removeClass('object-active');
	};
	
	this.resize = function() {
		windowResized();
	};
	
	if($container.length > 0) {
		$container.addClass('investment-plan--type-'+type);
		if($svg.length > 0) {
			$el = $svg;
			initPlan();
		} else if($img.length > 0) {
			$el = $img;
			$img.on('load', function() {
				initPlan();
			});
			if($img.get(0).complete) {
				initPlan();
			}
		}
	}
}
